// Global Theme Functions
const modco = {};
/* Killswitch function to prevent the theme from being duplicated.
document.addEventListener("DOMContentLoaded", function(event) {
	if( Shopify.theme.id != 140505874525){
		document.body.textContent = "";
	}
});
*/
modco.ajax_content = function( id = false, url = false, append = false, remove = false ){
	console.log('modco.ajax_content()');
	if( url && id ){
		var target = document.getElementById( id );
		fetch( url ).then( function( response ){ return response.text() } ).then( function ( html ){
			let parser = new DOMParser();
			let doc = parser.parseFromString( html, 'text/html' );
			var html = doc.getElementById( id );
			if( html ){
				if( append ){
					if( remove ){
						remove.remove()
					}
					target.innerHTML += html.innerHTML;
                    // URL not updated for infinite scroll to preserve back button functionality
                    // SEO is handled via hidden pagination links in build-pagination.liquid
					/*					
					// Update URL and canonical for infinite scroll
					window.history.replaceState('Page Navigation', false, url);
					// Update canonical tag
					var canonicalTag = document.querySelector('link[rel="canonical"]');
					var newCanonical = doc.querySelector('link[rel="canonical"]');
					if( canonicalTag && newCanonical ){
						canonicalTag.setAttribute('href', newCanonical.getAttribute('href'));
					}
				    */
				} else {
					target.innerHTML = html.innerHTML;
					window.history.replaceState('Page Navigation', false, url);
					// Update canonical tag for numbered pagination
					var canonicalTag = document.querySelector('link[rel="canonical"]');
					var newCanonical = doc.querySelector('link[rel="canonical"]');
					if( canonicalTag && newCanonical ){
						canonicalTag.setAttribute('href', newCanonical.getAttribute('href'));
					}
				}
				// Dispatch pagination loaded event for analytics/tracking
				let event = new CustomEvent('pagination-loaded', { detail: { url: url, append: append } });
				window.dispatchEvent(event);
			} else {
				window.location.href = url
			}
		} ).catch( function( error ){ console.log( error ) } )
	} else {
		console.error( 'modco.ajax_content() Error: Both "url" and "id" are required' )
	}
};
modco.popup_active = false;
modco.popup = function( html = false, popup_class = '', shade_class = 'bg_text', position = 'center' ){
	if( html ){
		modco.popup_active = true
		var event = new CustomEvent('control-body', { detail: { body_class: 'h-screen overflow-hidden'} });
		popup_class += ( popup_class == '' ? '' : ' ' ) +'fixed top-0 left-0 h-screen w-screen m-0';
		if( position == 'center'){
			popup_class += ' p-4 items-center justify-center';
		} 
		var popup_html = '<div id="modco_popup" class="'+ popup_class +'" style="z-index: 10000" @click.self="modco.popup()">'
			popup_html += '<div class="shade absolute inset-0 '+ shade_class +' fade_in_80" @click.prevent="modco.popup()"></div>';
			var content_class = 'z-10 overflow-auto fade_in';
			if( position == 'center'){
				content_class += ' relative w-auto max-w-full max-h-full';
			} else {
				content_class += ' absolute top-0 h-full max-w-full body '+ position +'-0 slide_'+ position;
			}
			var btn = '<button @click.prevent="modco.popup()" x-init="$el.focus()" class="absolute h-1 w-1 overflow-hidden opacity-0"><span class="sr-only">Close</span></button><button class="btn secondary absolute top-0 right-0 m-4 z-50" style="padding: var(--btn-py)" @click.prevent="modco.popup()">X</button>';

			popup_html += '<div class="'+ content_class +'">' + html;
			if( position == 'left'){
				popup_html += btn;
			}
			popup_html += '</div>';
			if( position != 'left'){
				popup_html += btn;
			}
		popup_html += '</div>';
		document.getElementById("theme_popup_container").innerHTML = popup_html;
		let popup = document.getElementById("modco_popup");
		popup.classList.remove("hidden");
		popup.classList.add("flex");
		// Initialize Alpine.js on the new popup element so @click directives work
		if (typeof Alpine !== 'undefined') {
			Alpine.initTree(popup);
		}
	} else {
		var event = new CustomEvent('control-body', { detail: { body_class: ''} });
		document.getElementById("theme_popup_container").innerHTML = '';
		modco.popup_active = false;
	}
	window.dispatchEvent(event);
}
// Image Gallery Popup - displays product images with navigation
  modco.image_gallery_popup = function(clickedElement) {
  	const productId = clickedElement.dataset.product;
  	const currentPosition = parseInt(clickedElement.dataset.position);

  	// Find all media elements for this product that have the modal action class
  	const allMedia = document.querySelectorAll(`[data-product="${productId}"].action_modal`);

  	if (allMedia.length === 0) return;

  	// Build array of media data with positions
  	const mediaItems = [];
  	allMedia.forEach(media => {
  		const position = parseInt(media.dataset.position);
  		const imgElement = media.querySelector('img');
  		if (imgElement) {
  			mediaItems.push({
  				position: position,
  				html: imgElement.outerHTML
  			});
  		}
  	});

  	// Sort by position
  	mediaItems.sort((a, b) => a.position - b.position);

  	if (mediaItems.length === 0) return;

  	// Find the index of the clicked image
  	const startIndex = mediaItems.findIndex(item => item.position === currentPosition);
  	const activePosition = startIndex >= 0 ? mediaItems[startIndex].position : mediaItems[0].position;

  	// Build gallery HTML with Alpine.js state
  	// Use viewport units for explicit sizing since children are absolutely positioned
  	let html = `<div class="product_gallery relative" style="width: 90vw; height: 80vh; max-width: 1200px;" x-data="{ active: ${activePosition}, count: ${mediaItems.length}, positions: [${mediaItems.map(m => m.position).join(',')}], getIndex(pos) { return this.positions.indexOf(pos); }, prev() { let idx = this.getIndex(this.active); idx = idx <= 0 ? this.count - 1 : idx - 1; this.active = this.positions[idx]; }, next() { let idx = this.getIndex(this.active); idx = idx >= this.count - 1 ? 0 : idx + 1; this.active = this.positions[idx]; } }">`;

  	// Add each image with conditional visibility
  	// @click.self on container closes popup when clicking outside the image
  	mediaItems.forEach(item => {
  		html += `<div class="absolute inset-0 flex items-center justify-center transition-opacity duration-200" :class="active == ${item.position} ? 'opacity-100 z-20' : 'opacity-0 z-10 pointer-events-none'" @click.self="modco.popup()">`;
  		html += item.html;
  		html += `</div>`;
  	});

  	// Add navigation arrows (only if more than 1 image)
  	if (mediaItems.length > 1) {
  		html += `<button class="btn secondary pointer-events-auto" style="position: absolute; left: 1rem; top: 50%; transform: translateY(-50%); z-index: 30; padding: 0.75rem 1rem;" @click.prevent="prev()" aria-label="Previous image"><i class="fa-angle-left fa-classic fa-solid"></i></button>`;
  		html += `<button class="btn secondary pointer-events-auto" style="position: absolute; right: 1rem; top: 50%; transform: translateY(-50%); z-index: 30; padding: 0.75rem 1rem;" @click.prevent="next()" aria-label="Next image"><i class="fa-angle-right fa-classic fa-solid"></i></button>`;
  	}

  	html += `</div>`;

  	modco.popup(html, 'img_popup');
}
// Cart Functions
modco.cart_conditions = function( cart = false ){
	console.log('modco.cart_conditions()');
	if( cart ){
		var order_tags = '';
		for ( item of cart.items ) {
			if( '_tags' in item.properties ){
				order_tags += item.properties._tags
			}
		}
		let unique_order_tags = order_tags.split('||').filter((e, i, self) => i === self.indexOf(e));
		let event = new CustomEvent('modco-cart-conditions', { detail: { item_count: cart.item_count, total_discount: cart.total_discount, items_subtotal_price: cart.items_subtotal_price, original_total_price: cart.original_total_price, total_price: cart.total_price, order_tags: unique_order_tags } });
		window.dispatchEvent(event);
	} else {
		console.error('modco.cart_conditions() Error: No cart passed');
	}
};
modco.get_cart = function(){
	console.log('modco.get_cart()');
	fetch( window.Shopify.routes.root + 'cart.js' ).then( response => { return response.json() } ).then( cart =>{
		console.log(cart);
		modco.cart_conditions(cart);
		return cart
	})
	.catch((error) => {
		console.error('modco.get_cart() Error:', error);
	});
};
modco.update_cart = function(form = false){
	console.log('modco.update_cart()');
	if(form){
		let formData = new FormData(form);
		fetch( window.Shopify.routes.root + 'cart/update.js', { method: 'POST', body: formData } ).then( response => { return response.json() } ).then( updated =>{
			//console.log( updated );
			modco.cart_conditions(updated);
			return updated;
		}).catch((error) => {
			console.error('modco.update_cart() Error:', error);
		});
	} else {
		console.error('modco.update_cart() Error: No form data provided');
	}
};
modco.remove_from_cart = function( url ){
	console.log('modco.remove_from_cart()');
	if( url ){
		fetch( url ).then( function( response ){
			modco.get_cart();
		} ).catch((error) => {
			console.error('modco.remove_from_cart() Error:', error);
		});
	} else {
		console.error('modco.remove_from_cart() Error: No URL data provided');
	}
};
modco.add_to_cart = function( form = false, url = false ){
	console.log('modco.add_to_cart()');
	if(form){
		let formData = new FormData(form);
		fetch( window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData } ).then( response => { return response.json() } ).then( added =>{
			console.log( added );
			modco.get_cart();
			if( url && url.startsWith('#')){
				let event = new CustomEvent('hashtag-trigger', { detail: { hashtag: url } });
				window.dispatchEvent(event);
			} else if( url ){
				window.location.href = url
			} else {
				return added
			}
		}).catch((error) => {
			console.error('modco.add_to_cart() Error:', error);
		});
	} else {
		console.error('modco.add_to_cart() Error: No form data provided');
	}
};

// Rebuy Integration - Listen for Rebuy cart changes to update mini cart
// Using debounce to prevent multiple rapid calls
(function() {
	let rebuyUpdateTimer = null;
	function handleRebuyCartChange(eventName) {
		clearTimeout(rebuyUpdateTimer);
		rebuyUpdateTimer = setTimeout(function() {
			console.log(eventName);
			modco.get_cart();
		}, 150);
	}

	document.addEventListener('rebuy:cart.change', function() {
		handleRebuyCartChange('Rebuy cart change detected');
	});
	document.addEventListener('rebuy:item.add', function() {
		handleRebuyCartChange('Rebuy item added');
	});
	document.addEventListener('rebuy.cart.change', function() {
		handleRebuyCartChange('Rebuy cart change detected (alt event)');
	});
	document.addEventListener('rebuy.add', function() {
		handleRebuyCartChange('Rebuy add detected');
	});
})();
